import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "取引先名", enum: "CUSTOMER_NAME" },
  { value: 2, text: "卸掛率", enum: "WHOLESALE_RATE" },
  { value: 3, text: "仕入掛率", enum: "PURCHASE_RATE" },
  { value: 4, text: "配送先名", enum: "SUPPLIER_DELIVERY_CD" },
  { value: 5, text: "出荷予定日", enum: "SHIP_PLAN_DATE" },
]);
